import { c as _c } from "react/compiler-runtime";
import { useSessionStore } from '@systemeio/util';
const WAITED_SHARING_IDS_LOCALE_STORAGE_KEY = 'WAITED_SHARING_IDS_LOCALE_STORAGE_KEY';
export const useWaitedSharingIdsStorage = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      parser: _temp,
      stringifier: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    getItem,
    setItem,
    removeItem
  } = useSessionStore(WAITED_SHARING_IDS_LOCALE_STORAGE_KEY, t0);
  let t1;
  if ($[1] !== getItem || $[2] !== setItem) {
    t1 = sharingId => {
      const ids = getItem() ?? new Set();
      ids.add(sharingId);
      setItem(ids);
    };
    $[1] = getItem;
    $[2] = setItem;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const addSharingId = t1;
  let t2;
  if ($[4] !== addSharingId || $[5] !== getItem || $[6] !== removeItem || $[7] !== setItem) {
    t2 = {
      getItem,
      setItem,
      removeItem,
      addSharingId
    };
    $[4] = addSharingId;
    $[5] = getItem;
    $[6] = removeItem;
    $[7] = setItem;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(value) {
  return new Set(JSON.parse(value));
}
function _temp2(value_0) {
  return JSON.stringify(Array.from(value_0));
}